import axios from 'axios';
import { config } from '../config';

export interface TenantFeatures {
  groupClassesEnabled: boolean;
  smsNotificationsEnabled: boolean;
  passesEnabled: boolean;
  groupClassCalendarViewEnabled: boolean;
  paymentCollectionEnabled: boolean;
  guestReservationsEnabled: boolean;
  shopEnabled?: boolean;
  bookingHorizonDays?: number;
  reservationsBlocked?: boolean;
  reservationsBlockedMessage?: string | null;
}

const getFeatures = async (siteNodeId: string): Promise<TenantFeatures> => {
  const response = await axios.get(`${config.apiUrl}/api/features/${siteNodeId}`);
  return response.data;
};

const isFeatureEnabled = async (siteNodeId: string, featureName: string): Promise<boolean> => {
  const response = await axios.get(`${config.apiUrl}/api/features/${siteNodeId}/${featureName}`);
  return response.data.enabled;
};

export const featuresApi = {
  getFeatures,
  isFeatureEnabled,
};
